<template>

    <div class="map-whisper-wrapper" ref="wrapperRef">
        <b-input-group>
            <b-form-input
                ref="input"
                id="mapWhisper"
                v-model="localModel"
                placeholder="Vaše lokace"
                autocomplete="off"
                @input="onInput"
                @focus="onFocus"
            ></b-form-input>
        </b-input-group>
        <ul v-if="showSuggest && suggestItems.length" class="map-whisper-suggest list-unstyled">
            <li
                v-for="(item, idx) in suggestItems"
                :key="idx"
                class="map-whisper-suggest-item"
                @mousedown.prevent="selectItem(item)"
            >
                {{ item.title || item.name }}<span v-if="item.secondRow">, {{ item.secondRow }}</span>
            </li>
        </ul>
    </div>

</template>

<script>

    import { suggest as mapySuggest } from '@/services/mapyApi.service';

    const CZ_BOX = 'BOX(12.0921668,48.5370786,18.8927040,51.0746358)';
    const DEBOUNCE_MS = 300;

    export default {
        name: 'MapWhisperTextBox',
        data() {
            return {
                localModel: this.model || '',
                localLocation: this.location || null,
                suggestItems: [],
                showSuggest: false,
                suggestDebounceTimer: null
            };
        },
        props: {
            model: {
                type: String,
                default: '',
                required: true
            },
            location: {
                required: false
            }
        },
        watch: {
            model(val) {
                this.localModel = val || '';
            },
            location(val) {
                this.localLocation = val;
            }
        },
        mounted() {
            this.localModel = this.model || '';
            this.localLocation = this.location || null;
            document.addEventListener('click', this.onClickOutside);
        },
        beforeDestroy() {
            document.removeEventListener('click', this.onClickOutside);
            if (this.suggestDebounceTimer) clearTimeout(this.suggestDebounceTimer);
        },
        methods: {
            onInput() {
                if (this.suggestDebounceTimer) clearTimeout(this.suggestDebounceTimer);
                const q = (this.localModel || '').trim();
                if (!q || q.length < 2) {
                    this.suggestItems = [];
                    this.showSuggest = false;
                    return;
                }
                this.suggestDebounceTimer = setTimeout(() => {
                    this.fetchSuggest(q);
                    this.$emit('update:model', this.localModel);
                }, DEBOUNCE_MS);
            },
            onFocus() {
                if (this.suggestItems.length) this.showSuggest = true;
            },
            async fetchSuggest(query) {
                const apiKey = this.$store?.state?.configuration?.configuration?.data?.mapyApiKey;
                if (!apiKey) {
                    this.suggestItems = [];
                    return;
                }
                try {
                    const items = await mapySuggest(query, apiKey, { limit: 8, locality: CZ_BOX });
                    this.suggestItems = items;
                    this.showSuggest = items.length > 0;
                } catch {
                    this.suggestItems = [];
                }
            },
            selectItem(item) {
                this.localModel = (item.title || item.name) + (item.secondRow ? ', ' + item.secondRow : '');
                this.localLocation = { coords: item.coords || (item.position ? { y: item.position.lat, x: item.position.lon } : null) };
                this.suggestItems = [];
                this.showSuggest = false;
                this.$emit('update:location', this.localLocation);
                this.$emit('update:model', this.localModel);
            },
            onClickOutside(e) {
                if (this.$refs.wrapperRef && !this.$refs.wrapperRef.contains(e.target)) {
                    this.showSuggest = false;
                }
            }
        }
    };

</script>

<style scoped>
    .map-whisper-wrapper {
        position: relative;
    }
    ul.map-whisper-suggest {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        z-index: 1000;
        margin: 0;
        padding: 0;
        background: #fff;
        border: 1px solid #ccc;
        border-top: none;
        max-height: 240px;
        overflow-y: auto;
        box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    }
    .map-whisper-suggest-item {
        padding: 8px 12px;
        cursor: pointer;
    }
    .map-whisper-suggest-item:hover {
        background: #f0f0f0;
    }
</style>
